import React from 'react';

function Back() {
  return (
    <svg width="13" height="7" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.664 4.844v1.258a.66.66 0 0 1-.191.464.64.64 0 0 1-.465.192c-.192 0-.356-.055-.465-.192L.191 4.215C.055 4.105 0 3.94 0 3.75a.64.64 0 0 1 .191-.465L2.543.934a.66.66 0 0 1 .465-.192c.164 0 .328.082.465.192.109.136.191.3.191.464v1.258h8.258c.082 0 .164.055.219.11.054.054.109.136.109.218v1.532c0 .109-.055.191-.11.246a.31.31 0 0 1-.218.082H3.664z"
        fill="#000"
      />
    </svg>
  );
}

export default Back;
